import { connect } from 'react-redux';

import EffectSwitch from '@js/components/Common/EffectSwitch';

import {
  CLOSE_EXCEPTION_MODAL,
} from '@js/constants/actionsTypes';

const mapStateToProps = (state) => {
  const {
    isLoading,
    isShowExceptionModal,
    apiExceptionMessage,
  } = state.commonState;

  return {
    isLoading,
    isShowExceptionModal,
    apiExceptionMessage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // 關閉錯誤提示窗口
  closeExceptionModal: (payload) => dispatch({ type: CLOSE_EXCEPTION_MODAL, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(EffectSwitch);
